export const iconFontAwesomeFoodBeverageMartiniGlassCitrus = (
	<i className="fa-solid fa-martini-glass-citrus"></i>
);
